import styled from 'styled-components';
import { Timeline as MuiTimeline } from '@mui/lab';

export const CustomTimeline = styled(MuiTimeline)``;
